import ReactGA from 'react-ga4'
import {GAID} from './editable-stuff/constants'

const GA_MEASUREMENT_ID = GAID

export const initGA = () => {
    ReactGA.initialize(GA_MEASUREMENT_ID)
}

export const logPageView = () => {
    ReactGA.send({hitType: 'pageview', page: window.location.pathname})
}